import { useState } from 'react'
import styles from './PinterestRefreshBoardsButton.pcss'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { connectedDestinationsSelector, getPinterestBoards } from 'services/destinations'
import { BRAND_PINTEREST } from 'shared'
import { StoreThunkDispatch } from 'store/state'
import { setPinterestProfileBoards } from 'services/compose'
import CircularProgress from '@mui/material/CircularProgress'

export function PinterestRefreshBoardsButton({ className }: { className?: string }) {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const profiles = useSelector(connectedDestinationsSelector)
  const pinterestProfiles = Object.values(profiles).filter((profile) => profile.type === BRAND_PINTEREST)
  const [isRefreshing, setIsRefreshing] = useState(false)

  const refreshBoards = () => {
    setIsRefreshing(true)
    Promise.all(pinterestProfiles.map(profile => {
      return dispatch(getPinterestBoards({ profile, noCache: true })).unwrap().then((response) => {
        dispatch(setPinterestProfileBoards({ ppid: profile.ppid, boards: response.boards }))
      }).catch(() => {
        // NOTE: keep refreshing the remaining profiles when one of them fails
      })
    }))
      .finally(() => {
        setIsRefreshing(false)
      })
  }

  return (
    <span role="button" onClick={refreshBoards} className={`${styles.btn} ${isRefreshing ? styles.disabled : ''} ${className || ''}`}>
      <FormattedMessage id="composer.labels.refresh-pinterest-boards" />
      {isRefreshing && <CircularProgress className={styles.loader} size="12px" />}
    </span>
  )
}
